import { useContext } from "react";
import {
  Box,
  ColumnLayout,
  Container,
  Select,
  SpaceBetween,
} from "@amzn/awsui-components-react";
import Button from "@amzn/awsui-components-react/polaris/button";
import Input from "@amzn/awsui-components-react/polaris/input";
import { OrderIdContext, StageContext } from "../contexes/OrderIdContext";
import { useSearch } from "../hooks/useSearch";
import { STAGE_OPTIONS } from "../constants";
import { Stage } from "../lusca-search-api/generated-src";

interface Props {
  children: React.ReactNode;
  setStage: React.Dispatch<React.SetStateAction<Stage>>;
}

export default function SearchBar({ children, setStage }: Props) {
  const stage = useContext(StageContext);

  const {
    orderId,
    orderIdQuery,
    selectedOption,
    setOrderIdQuery,
    devUserQuery,
    setDevUserQuery,
    searchParamsFor,
    handleSearch,
    handleStageSelect,
    handleKeyDown,
  } = useSearch(stage, setStage);

  const searchHref = orderIdQuery
    ? `/?${new URLSearchParams(searchParamsFor(orderIdQuery)).toString()}`
    : undefined;

  return (
    <OrderIdContext.Provider value={orderId}>
      <SpaceBetween size="xl">
        <Container>
          <ColumnLayout columns={1}>
            <Box padding={{ top: "s", bottom: "s" }}>
              <div className="custom-search-bar">
                <div className="custom-search-bar-input">
                  <Input
                    onChange={({ detail }) =>
                      setOrderIdQuery(detail.value.trim())
                    }
                    value={orderIdQuery}
                    onKeyDown={({ detail }) => handleKeyDown(detail)}
                    type="search"
                    inlineLabelText="Transaction ID"
                    placeholder="Enter Transaction Id (TVOD: Order ID, Subs: AUID)"
                    autoFocus
                  />
                </div>
                {selectedOption.value === Stage.Dev && (
                  <div className="custom-search-bar-user">
                    <Input
                      onChange={({ detail }) =>
                        setDevUserQuery(detail.value.trim())
                      }
                      value={devUserQuery}
                      onKeyDown={({ detail }) => handleKeyDown(detail)}
                      inlineLabelText="User"
                      placeholder="User"
                    />
                  </div>
                )}
                <Select
                  className="custom-select"
                  inlineLabelText="Stage"
                  selectedOption={selectedOption}
                  placeholder="Choose an environment"
                  onChange={({ detail }) =>
                    handleStageSelect(detail.selectedOption)
                  }
                  options={STAGE_OPTIONS}
                  selectedAriaLabel="Selected"
                />
                <div className="custom-search-bar-items">
                  <Button
                    href={searchHref}
                    onFollow={(e) => {
                      e.preventDefault();
                      handleSearch();
                    }}
                    variant="primary"
                    className="inp"
                  >
                    Search
                  </Button>
                </div>
              </div>
            </Box>
          </ColumnLayout>
        </Container>
        {children}
      </SpaceBetween>
    </OrderIdContext.Provider>
  );
}
